export default __webpack_public_path__ + "static/media/logo03.ed39a486.svg";